export const DAILY_PUZZLES = [
  {
    id: 'p001',
    title: 'Back Rank Mate',
    theme: 'Mate in 1',
    hint: 'The rook can deliver checkmate along the back rank.',
    fen: '6k1/5ppp/8/8/8/8/8/3R2K1 w - - 0 1',
    sideToMove: 'white',
    solution: 'd1d8',
    crowns: 10,
  },
  {
    id: 'p002',
    title: 'Smothered Mate',
    theme: 'Mate in 1',
    hint: "The knight can deliver checkmate. The king's own pieces trap it.",
    fen: '6rk/6pp/7N/8/8/8/8/6K1 w - - 0 1',
    sideToMove: 'white',
    solution: 'h6f7',
    crowns: 15,
  },
  {
    id: 'p003',
    title: "Scholar's Mate",
    theme: 'Mate in 1',
    hint: 'The queen can take the pawn on f7 — delivering checkmate.',
    fen: 'r1bqkb1r/pppp1ppp/2n2n2/4p2Q/2B1P3/8/PPPP1PPP/RNB1K1NR w KQkq - 4 4',
    sideToMove: 'white',
    solution: 'h5f7',
    crowns: 10,
  },
  {
    id: 'p004',
    title: 'Knight Fork',
    theme: 'Fork',
    hint: 'One knight move attacks the king AND the queen at the same time.',
    fen: '8/4k3/1q6/8/8/2N5/8/4K3 w - - 0 1',
    sideToMove: 'white',
    solution: 'c3d5',
    crowns: 15,
  },
  {
    id: 'p005',
    title: 'Discovered Check',
    theme: 'Discovered Attack',
    hint: 'Moving the knight reveals a devastating bishop check on the king.',
    fen: '4k3/8/2N5/1B6/8/8/8/4K3 w - - 0 1',
    sideToMove: 'white',
    solution: 'c6d4',
    crowns: 20,
  },
  {
    id: 'p006',
    title: 'Bishop Skewer',
    theme: 'Skewer',
    hint: 'The bishop can attack the king along a diagonal. The queen hides behind it.',
    fen: '6q1/8/4k3/8/8/8/8/1B2K3 w - - 0 1',
    sideToMove: 'white',
    solution: 'b1a2',
    crowns: 20,
  },
  {
    id: 'p007',
    title: 'Queen Check & Win',
    theme: 'Fork',
    hint: 'A queen check on the back rank forces the king to move — then you win the rook.',
    fen: 'r5k1/6pp/8/8/8/8/8/3Q2K1 w - - 0 1',
    sideToMove: 'white',
    solution: 'd1d8',
    crowns: 15,
  },
  {
    id: 'p008',
    title: 'Rook Ladder',
    theme: 'Mate in 1',
    hint: "One rook delivers checkmate while the other covers the king's escape.",
    fen: '7k/7R/6R1/8/8/8/8/7K w - - 0 1',
    sideToMove: 'white',
    solution: 'h7h8',
    crowns: 10,
  },
  {
    id: 'p009',
    title: 'Queen Pin',
    theme: 'Pin',
    hint: 'Attack the rook that cannot move — it is pinned to the king.',
    fen: '4k3/4r3/8/8/8/8/8/Q3K3 w - - 0 1',
    sideToMove: 'white',
    solution: 'a1e5',
    crowns: 20,
  },
  {
    id: 'p010',
    title: 'Rook & King Box',
    theme: 'Mate in 1',
    hint: 'The rook delivers checkmate. The white king controls the escape square.',
    fen: 'k1K5/8/1R6/8/8/8/8/8 w - - 0 1',
    sideToMove: 'white',
    solution: 'b6b8',
    crowns: 10,
  },
  {
    id: 'p011',
    title: 'Arabian Mate',
    theme: 'Mate in 1',
    hint: 'Rook and knight combine to deliver checkmate in the corner.',
    fen: '6k1/8/5NRK/8/8/8/8/8 w - - 0 1',
    sideToMove: 'white',
    solution: 'g6g8',
    crowns: 15,
  },
  {
    id: 'p012',
    title: 'Double Attack',
    theme: 'Fork',
    hint: 'The queen can attack the rook and the undefended bishop at once.',
    fen: '2b5/8/8/8/8/8/8/Q2r2K1 w - - 0 1',
    sideToMove: 'white',
    solution: 'a1d4',
    crowns: 15,
  },
  {
    id: 'p013',
    title: 'Pawn Promotion',
    theme: 'Promotion',
    hint: 'Advance the pawn to the last rank and promote to a queen — delivering checkmate.',
    fen: '8/3P4/8/8/8/8/8/3K1k2 w - - 0 1',
    sideToMove: 'white',
    solution: 'd7d8q',
    crowns: 20,
  },
  {
    id: 'p014',
    title: 'Anastasia\'s Mate',
    theme: 'Mate in 1',
    hint: 'The rook delivers checkmate with the knight cutting off the king.',
    fen: '5rk1/4Rnpp/8/8/8/8/8/6K1 w - - 0 1',
    sideToMove: 'white',
    solution: 'e7e8',
    crowns: 15,
  },
];

// Returns today's puzzle seeded by calendar date
export function getDailyPuzzle() {
  const today = new Date();
  const dayIndex = Math.floor(today.getTime() / 86400000);
  return DAILY_PUZZLES[dayIndex % DAILY_PUZZLES.length];
}

// Converts FEN position string → 8×8 grid of { char, isWhite } | null
export function fenToGrid(fen) {
  const position = fen.split(' ')[0];
  const CHARS = {
    p:'♟', r:'♜', n:'♞', b:'♝', q:'♛', k:'♚',
    P:'♙', R:'♖', N:'♘', B:'♗', Q:'♕', K:'♔',
  };
  const grid = Array.from({ length: 8 }, () => Array(8).fill(null));
  position.split('/').forEach((row, r) => {
    let c = 0;
    for (const ch of row) {
      if (/\d/.test(ch)) { c += parseInt(ch, 10); continue; }
      grid[r][c] = { char: CHARS[ch], isWhite: ch === ch.toUpperCase() };
      c++;
    }
  });
  return grid;
}

// Converts algebraic square (e.g. "d1") → [row, col]
export function sqToRC(sq) {
  return [8 - parseInt(sq[1], 10), sq.charCodeAt(0) - 97];
}

// Converts [row, col] → algebraic square (e.g. "d1")
export function rcToSq(r, c) {
  return String.fromCharCode(97 + c) + (8 - r);
}
